export default __webpack_public_path__ + "static/media/Malaki_Home.b972db6b.jpg";